module.exports = __webpack_public_path__ + "static/media/tmcf-feed-update-8-6.e5e429fd.png";